import { render, staticRenderFns } from "./VerifyGroup.vue?vue&type=template&id=08fb5779"
import script from "./VerifyGroup.vue?vue&type=script&lang=js"
export * from "./VerifyGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports